export function PageContainer({ className, ...props }) {
  return (
    <div
      className={`flex flex-col h-full max-w-[1440px] mx-auto animate-fadeIn ${className}`}
      {...props}
    />
  );
}
